import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { AdminUser } from '../models';

@Injectable({ providedIn: 'root' })
export class AdminUsersApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/BackofficeUsers`;

  getUsers() {
    return this.httpClient.get<AdminUser[]>(`${this.baseUrl}`);
    // return of(this.mockData);
  }

  getUser(id: string) {
    return this.httpClient.get(`${this.baseUrl}/${id}`);
    // return of(this.mockData.find((user) => user.id === id));
  }

  createUser(user: {
    email: string;
    userName: string;
    role: string;
    phoneNumber: string | null;
  }) {
    return this.httpClient.post(`${this.baseUrl}`, user).pipe(
      catchError((error) => {
        if (error.error === 'User with this email already exists') {
          return throwError(
            () => "L'indirizzo email specificato è già in uso.",
          );
        }

        return throwError(
          () =>
            "Si è verificato un errore inaspettato. Riprova più tardi o contatta l'assistenza tecnica fornendo i dettagli dell'azione che stavi compiendo.",
        );
      }),
    );
  }

  deleteUser(id: string) {
    return this.httpClient.delete(`${this.baseUrl}/${id}`);
  }

  updateUserRole(id: string, role: string) {
    return this.httpClient.put(`${this.baseUrl}/${id}/role`, { role });
  }
}
